import dayjs from 'dayjs';
import { AgentCommissionStatus } from 'app/shared/model/AgentCommissionDto';

export const END_DATE_BEFORE_START_MESSAGE = 'Date To cannot be earlier than Date From';
export const END_DATE_IN_PAST_MESSAGE = 'Date To cannot be in the past';
export function validateEndDate(
    startDate: string | undefined,
    endDate: string | undefined | null,
    status: AgentCommissionStatus
): string | null {
    if (!endDate) {
        return null;
    }

    const end = dayjs(endDate);
    if (!end.isValid()) {
        return null;
    }

    if (startDate) {
        const start = dayjs(startDate);
        if (start.isValid() && end.isBefore(start, 'day')) {
            return END_DATE_BEFORE_START_MESSAGE;
        }
    }

    const isExistingConfiguration = status !== AgentCommissionStatus.New;
    if (isExistingConfiguration && end.isBefore(dayjs(), 'day')) {
        return END_DATE_IN_PAST_MESSAGE;
    }

    return null;
}